import taxiKo from './ko/taxi.json';
import taxiEn from './en/taxi.json';

const ko = {
  taxi: taxiKo,
};
const en = {
  taxi: taxiEn,
};

export { ko, en };
